import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import "./ExistingOrders.css";
import {
  // PlusOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router";
import { Button, Col, Row, Tag, Typography,Avatar, message } from "antd";
import SearchInput from "../../../components/Input/SearchInputs/SearchInput";
// import SearchDropdown from "../../../components/DropDown/SearchDropdown";
import "./ExistingOrders.css";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";
import {
  useLazyGetExistingOrdertTableQuery,
  useLazyGetOrdersListExcelQuery,
} from "../../../apis/ManageOrders";
import { useDispatch, useSelector } from "react-redux";
import { getmanageOrdersTableData } from "../../../redux/slices/manageOrders/action";
import { manageOrdersDataSelector } from "../../../redux/slices/manageOrders/selector";
import { DownArrow } from "../../../components/Icons/DownArrow";
import { UpArrow } from "../../../components/Icons/UpArrow";
import { SubOrderComponent } from "../../Dashboard/SubOrderComponent";
import { ReactComponent as QwikIcon } from "../../../assets/icons/Qwik-icon.svg";
import {
  dateFormat,
  // handlePdfDownload,
} from "../../../commonFuntions/CommonUtilFunctions";
import DateRangePicker from "../../../components/DateRangePicker/DateRangePicker";
import CustomSelect from "../../../components/SelectableDropdown/CustomSelect/CustomSelect";
import CustomTableWithPagination from "../../../components/CustomTableWithPagination/CustomTableWithPagination";
import {
  getBillingAddress,
  getDeliveryAddress,
} from "../../../redux/slices/createQuote/action";
import { Link } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { saveAs } from "file-saver";
import NoDataFound from "../../../components/EmptyTable/NoDataFound";
import { CreateOrderModal } from "../../../components/Modal/OrdersModal/CreateOrderModal/CreateOrderModal";
import {getNameInitials} from "../../../commonFuntions/CommonUtilFunctions";
const { Text } = Typography;
const isValidRfqId = (rfqId) => {
  if (rfqId === null || rfqId === undefined) return false;
  const normalizedRfqId = String(rfqId).trim().toLowerCase();
  return normalizedRfqId && normalizedRfqId !== "n/a";
};

const handleTableData = (data) => {
  let tableData = [];
  data?.results?.map((item) => {
    var reporting_manager = null
    if(item.reporting_manager){
      reporting_manager = item.reporting_manager.reporting_person
     
    }

    tableData.push({
      id: item?.id,
      key: item?.order_id,
      order_id: item?.order_id,
      date: item?.created_at,
      name: item?.name,
      mobile_number: item?.mobile_number,
      status: item?.order_status,
      total: item?.total,
      email: item?.email || "",
      rfq_id: item?.rfq_details?.rfq_id,
      reporting_manager : reporting_manager,
      is_quick_commerce_order: item?.is_quick_commerce_order ?? false,
      sub_orders: item?.sub_orders?.map((element) => {
        const obj = {
          subId: element?.suborder_id,
          itemName: element?.vendor_name,
          subStatus: element?.status,
          bmp_id: element?.bmp_id,
          subTotal: Number(element?.total).toFixed(2),
          order_type: element?.order_type ?? item?.order_type,
          quick_commerce:
            element?.quick_commerce ??
            item?.is_quick_commerce_order ??
            item?.quick_commerce ??
            (element?.order_type ?? item?.order_type) === "QUICK_ORDER",
        };
        return obj;
      }),
    });
    return null;
  });
  return tableData;
};

const ExistingOrders = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectorData = useSelector(manageOrdersDataSelector);
  const [searchedValue, setSearchedValue] = useState({});
  const [orderStatusFilter, setOrderStatusFilter] = useState();
  const [orderReportingFilter, setOrderReportingFilter] = useState();
  const [orderTypeFilter, setOrderTypeFilter] = useState();
  const [reportingManagers,setReportingManagers] = useState([])

  const [dateSearch, setDateSearch] = useState({
    start_date: "",
    end_date: "",
  });
  const [sorterState, setSorterState] = useState({
    order_id: "",
    created_at: "",
  });
  const [dateFilter, setDateFilter] = useState();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [orderTableApi, { data: orderData, isFetching: isLoading }] =
    useLazyGetExistingOrdertTableQuery();
  const [
    excelApi,
    {
      isFetching: exlLoading,
      // data: excelApiData
    },
  ] = useLazyGetOrdersListExcelQuery();
  const [tableDataSource, setTableDataSource] = useState([]);
  const handleOpenModal = () => {
    setOpenCreateModal(true);
  };
  const handleCloseModal = () => {
    setOpenCreateModal(false);
  };
  useEffect(() => {
    orderTableApi();

    dispatch(getDeliveryAddress({}));
    dispatch(getBillingAddress({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (orderData?.status) {  
      setReportingManagers(orderData?.data?.reporting_managers)
      dispatch(getmanageOrdersTableData(orderData?.data));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderData]);

  useEffect(() => {
    if (selectorData) {
      const data = selectorData ? handleTableData(selectorData) : "";
      setTableDataSource(data);
    }
  }, [selectorData]);
  // const handleDetailNav = (record) => {
  //   navigate(`/admin/orders/order-details/${record?.id}`, {
  //     state: { id: record?.id },
  //   });
  // };
  // const handleNavigateToRFQDetails = (id) => {
  //   navigate(`/admin/rfq/quotes/${id}`, { state: { id } });
  // };
  const defaultExpandable = {
    expandedRowRender: (record) => {
      return record?.sub_orders?.map((obj) => (
        <SubOrderComponent record={obj} />
      ));
    },
    expandIcon: ({ expanded, onExpand, record }) =>
      expanded ? (
        <UpArrow className={"cursor"} onClick={(e) => onExpand(record, e)} />
      ) : (
        <DownArrow className={"cursor"} onClick={(e) => onExpand(record, e)} />
      ),
  };
  const handleChange = (value) => {
    let formattedDate = null;

    switch (value) {
      case "Today":
        formattedDate = dayjs().format("YYYY-MM-DD");
        break;
      case "Yesterday":
        formattedDate = dayjs().subtract(1, "day").format("YYYY-MM-DD");
        break;
      case "last_7_day":
        formattedDate = dayjs().subtract(6, "day").format("YYYY-MM-DD");
        break;
      case "last_30_day":
        formattedDate = dayjs().subtract(29, "day").format("YYYY-MM-DD");
        break;
      case "last_60_day":
        formattedDate = dayjs().subtract(59, "day").format("YYYY-MM-DD");
        break;
      case "Custom":
        formattedDate = "Custom";
        break;
      default:
        break;
    }

    const currentDate = dayjs().format("YYYY-MM-DD");
    if (value !== "Custom" && value !== null) {
      if (value === "clear_date") {
        orderTableApi({
          ...(orderStatusFilter && {status: orderStatusFilter}),
          ...(orderReportingFilter && {reporting_manager: orderReportingFilter}),
          ...(orderTypeFilter && {order_type: orderTypeFilter}),
          ...(searchedValue?.search && { search: searchedValue?.search }),
          ...(sorterState.order_id && { sort_by: sorterState.order_id }),
          ...(sorterState.created_at && { sort_by: sorterState.created_at }),
          page: 1,
        });
        setDateSearch({
          start_date: "",
          end_date: "",
        });
      } else {
        orderTableApi({
          start_date: formattedDate,
          end_date: currentDate,
          ...(orderStatusFilter && {status: orderStatusFilter}),
          ...(orderReportingFilter && {reporting_manager: orderReportingFilter}),
          ...(orderTypeFilter && {order_type: orderTypeFilter}),
          ...(searchedValue?.search && { search: searchedValue?.search }),
          ...(sorterState.order_id && { sort_by: sorterState.order_id }),
          ...(sorterState.created_at && { sort_by: sorterState.created_at }),
          page: 1,
        });
        setDateSearch({
          start_date: formattedDate,
          end_date: currentDate,
        });
      }

      setCurrentPage(1);
    }
    setDateFilter(value);
  };

  const handleChangeRangePicker = (dates, dateStrings) => {
    if (dates && dates?.length === 2) {
      const startDateFormatted = dates[0].format("YYYY-MM-DD");
      const endDateFormatted = dates[1].format("YYYY-MM-DD");
      orderTableApi({
        start_date: startDateFormatted,
        end_date: endDateFormatted,
        ...(orderStatusFilter && {status: orderStatusFilter}),
        ...(orderReportingFilter && {reporting_manager: orderReportingFilter}),
        ...(orderTypeFilter && {order_type: orderTypeFilter}),
        ...(searchedValue?.search && { search: searchedValue?.search }),
        ...(sorterState.order_id && { sort_by: sorterState.order_id }),
        ...(sorterState.created_at && { sort_by: sorterState.created_at }),
        page: 1,
      });
      setDateSearch({
        start_date: startDateFormatted,
        end_date: endDateFormatted,
      });

      setCurrentPage(1);
    }
  };
  const handleSearchedValue = (params) => {
    setSearchedValue(params);
    setCurrentPage(1);
  };
  const handlePageChange = async (currPage) => {
    const params = {
      page: currPage,
      ...(orderStatusFilter && {status: orderStatusFilter}),
      ...(orderReportingFilter && {reporting_manager: orderReportingFilter}),
      ...(orderTypeFilter && {order_type: orderTypeFilter}),
      ...(searchedValue && { search: searchedValue?.search }),
      ...(dateSearch?.start_date && { start_date: dateSearch?.start_date }),
      ...(dateSearch?.end_date && { end_date: dateSearch?.end_date }),
      ...(sorterState.order_id && { sort_by: sorterState.order_id }),
      ...(sorterState.created_at && { sort_by: sorterState.created_at }),
    };
    setCurrentPage(currPage);
    await orderTableApi(params);
  };

  const orderStatusOptions =[
    { key: 1, value: "Order Created", label: "Order Created" },
    { key: 2, value: "Order Rejected", label: "Order Rejected" },
    { key: 3, value: "Order Delivered", label: "Order Delivered" },
    { key: 4, value: "Order Cancelled", label: "Order Cancelled" },
    { key: 7, value: "Out for delivery", label: "Out for delivery" },
    { key: 5, value: "Waiting", label: "Waiting" },
    { key: 6, value: "Ready for Pickup", label: "Ready for Pickup" },
    { key: 9, value: "Delivered", label: "Delivered" },
    { key: 10, value: "Cancelled", label: "Cancelled" },
    {
      key: 11,
      value: "clear",
      label: (
        <Col style={{ color: "#006644", fontWeight: "500" }}>Clear</Col>
      ),
    },
  ]
  const options = [
    {
      key: 1,
      value: "Today",
      label: "Today",
    },
    {
      key: 2,
      value: "Yesterday",
      label: "Yesterday",
    },
    {
      key: 3,
      value: "last_7_day",
      label: "Last 7 day",
    },
    {
      key: 4,
      value: "last_30_day",
      label: "Last 30 day",
    },
    {
      key: 5,
      value: "last_60_day",
      label: "Last 60 day",
    },
    {
      key: 6,
      value: "Custom",
      label: "Custom",
    },
    {
      key: 7,
      value: "clear_date",
      label: (
        <Col style={{ color: "#006644", fontWeight: "500" }}>Clear Date</Col>
      ),
    },
  ];
  const orderTypeOptions = [
    { key: 1, value: "NORMAL_ORDER", label: "Normal order" },
    { key: 2, value: "QUICK_ORDER", label: "Qwik order" },
    { key: 3, value: "STORE_ORDER", label: "Store order" },
    {
      key: 4,
      value: "clear",
      label: (
        <Col style={{ color: "#006644", fontWeight: "500" }}>Clear</Col>
      ),
    },
  ];

  const handleStatusChange = (value)=>{
    setCurrentPage(1);

    if (value === "clear"){
      const params = {
        status: "",
        ...(orderReportingFilter && {reporting_manager: orderReportingFilter}),
        ...(orderTypeFilter && {order_type: orderTypeFilter}),
        ...(currentPage && { page: 1 }),
        ...(searchedValue && { search: searchedValue?.search }),
        ...(dateSearch.start_date && { start_date: dateSearch.start_date }),
        ...(dateSearch.end_date && { end_date: dateSearch.end_date }),
        ...(sorterState.rfq_id && { sort_by: sorterState.rfq_id }),
        ...(sorterState.created_at && { sort_by: sorterState.created_at }),
      };

      orderTableApi(params)
      setOrderStatusFilter()
      return
    }

    
   const params = {
    status: value,
    ...(orderReportingFilter && {reporting_manager: orderReportingFilter}),
    ...(orderTypeFilter && {order_type: orderTypeFilter}),
    ...(currentPage && { page: 1 }),
    ...(searchedValue && { search: searchedValue?.search }),
    ...(dateSearch.start_date && { start_date: dateSearch.start_date }),
    ...(dateSearch.end_date && { end_date: dateSearch.end_date }),
    ...(sorterState.rfq_id && { sort_by: sorterState.rfq_id }),
    ...(sorterState.created_at && { sort_by: sorterState.created_at }),
  };

    orderTableApi(params);
    setOrderStatusFilter(value)
  }

  const handleReportingChange = (value)=>{
    setCurrentPage(1);

    if (value === "clear"){
      const params = {
        reporting_manager: "",
        ...(orderStatusFilter && {status: orderStatusFilter}),
        ...(orderTypeFilter && {order_type: orderTypeFilter}),
        ...(currentPage && { page: 1 }),
        ...(searchedValue && { search: searchedValue?.search }),
        ...(dateSearch.start_date && { start_date: dateSearch.start_date }),
        ...(dateSearch.end_date && { end_date: dateSearch.end_date }),
        ...(sorterState.rfq_id && { sort_by: sorterState.rfq_id }),
        ...(sorterState.created_at && { sort_by: sorterState.created_at }),
      };

      orderTableApi(params)
      setOrderReportingFilter()
      return
    }
    const params = {
      reporting_manager: value,
      ...(orderStatusFilter && {status: orderStatusFilter}),
      ...(orderTypeFilter && {order_type: orderTypeFilter}),
      ...(currentPage && { page: 1 }),
      ...(searchedValue && { search: searchedValue?.search }),
      ...(dateSearch.start_date && { start_date: dateSearch.start_date }),
      ...(dateSearch.end_date && { end_date: dateSearch.end_date }),
      ...(sorterState.rfq_id && { sort_by: sorterState.rfq_id }),
      ...(sorterState.created_at && { sort_by: sorterState.created_at }),
    };

    orderTableApi(params);
    setOrderReportingFilter(value)

  }
  const handleOrderTypeChange = (value) => {
    setCurrentPage(1);

    if (value === "clear") {
      const params = {
        order_type: "",
        ...(orderReportingFilter && { reporting_manager: orderReportingFilter }),
        ...(orderStatusFilter && { status: orderStatusFilter }),
        ...(currentPage && { page: 1 }),
        ...(searchedValue && { search: searchedValue?.search }),
        ...(dateSearch.start_date && { start_date: dateSearch.start_date }),
        ...(dateSearch.end_date && { end_date: dateSearch.end_date }),
        ...(sorterState.rfq_id && { sort_by: sorterState.rfq_id }),
        ...(sorterState.created_at && { sort_by: sorterState.created_at }),
      };

      orderTableApi(params);
      setOrderTypeFilter();
      return;
    }

    const params = {
      order_type: value,
      ...(orderReportingFilter && { reporting_manager: orderReportingFilter }),
      ...(orderStatusFilter && { status: orderStatusFilter }),
      ...(currentPage && { page: 1 }),
      ...(searchedValue && { search: searchedValue?.search }),
      ...(dateSearch.start_date && { start_date: dateSearch.start_date }),
      ...(dateSearch.end_date && { end_date: dateSearch.end_date }),
      ...(sorterState.rfq_id && { sort_by: sorterState.rfq_id }),
      ...(sorterState.created_at && { sort_by: sorterState.created_at }),
    };

    orderTableApi(params);
    setOrderTypeFilter(value);
  };

  function convertToExportOptions(data) {
    var options =  data.map(item => ({
      key: item.id,
      value: item.id,
      label: item.reporting_person,
      
    }));
    options.push( {
      key: 9999,
      value: "clear",
      label: (
        <Col style={{ color: "#006644", fontWeight: "500" }}>Clear</Col>
      ),
    },)
    return options
  }

  const sorterChange = (item) => {
    let key = item;
    setSorterState({
      // ...sorterState,
      [key.replace("-", "")]: item,
    });
    orderTableApi({
      sort_by: item,
      ...(orderReportingFilter && {reporting_manager: orderReportingFilter}),
      ...(orderStatusFilter && {status: orderStatusFilter}),
      ...(orderTypeFilter && {order_type: orderTypeFilter}),
      ...(searchedValue?.search && { search: searchedValue?.search }),
      ...(dateSearch?.start_date && { start_date: dateSearch?.start_date }),
      ...(dateSearch?.end_date && { end_date: dateSearch?.end_date }),
      page: 1,
    });
  };
  const columns = [
    {
      width: "200px",
      fixed: "left",
      flex: 2,
      title: (
        <>
          <Col className="title_sorter">
            <Text className="sorter_heading">Order ID</Text>
            <Text className="sorter_container_icon">
              <CaretUpOutlined
                style={{
                  color: sorterState?.order_id === "order_id" ? "" : "grey",
                }}
                onClick={() => sorterChange("order_id")}
                className="sorter_icon"
              />
              <CaretDownOutlined
                style={{
                  color: sorterState?.order_id === "-order_id" ? "" : "grey",
                }}
                onClick={() => sorterChange("-order_id")}
                className="sorter_icon"
              />
            </Text>
          </Col>
        </>
      ),
      // title: "Order ID",
      key: 1,
      dataIndex: "order_id",

      render: (params, record) => {
        return (
          <Col className="order-id-with-icon">
            <Link
              className="order-id-text"
              to={`/admin/orders/order-details/${record?.id}`}
              // onClick={() => handleDetailNav(record)}
              target="_blank"
            >
              {params}
            </Link>
            {record?.is_quick_commerce_order && (
              <QwikIcon title="Qwick Order" width={24} height={24} className="order-id-qwik-icon" />
            )}
          </Col>
        );
      },
    },
    {
      // fixed: "left",
      flex: 2,
      width: "200px",
      // title: "Date",
      title: (
        <>
          <Col className="title_sorter">
            <Text className="sorter_heading">Date</Text>
            <Text className="sorter_container_icon">
              <CaretUpOutlined
                style={{
                  color: sorterState?.created_at === "created_at" ? "" : "grey",
                }}
                onClick={() => sorterChange("created_at")}
                className="sorter_icon"
              />
              <CaretDownOutlined
                style={{
                  color:
                    sorterState?.created_at === "-created_at" ? "" : "grey",
                }}
                onClick={() => sorterChange("-created_at")}
                className="sorter_icon"
              />
            </Text>
          </Col>
        </>
      ),
      key: 2,
      dataIndex: "date",
      render: (params, record) => {
        return <Text>{dateFormat(params)}</Text>;
      },
    },
    {
      // fixed: "left",
      flex: 1,
      title: "Name",
      width: "180px",
      key: 3,
      dataIndex: "name",
    },
    {
      flex: 1,
      title: "Assigned to",
      width: "200px",
      key: 3,
      dataIndex: "reporting_manager",
      render: (params, record) => {
        return (
          <>

      {params === null ? (
        <Text type="danger">Not assigned</Text>
      ) : (
        <div>
         <Avatar style={{ backgroundColor: '#4295a5', marginRight: '8px',marginTop:'8px' }}>
            {getNameInitials(params)}
          </Avatar>
           <Text type="">{params}
           </Text>
        </div>
      )}          </>
        );
      },
    },
    {
      // fixed: "left",
      flex: 1,
      title: "Business mobile",
      width: "150px",

      key: 4,
      dataIndex: "mobile_number",
    },
    {
      // fixed: "left",
      flex: 1,
      title: "Email",
      width: "200px",

      key: 5,
      dataIndex: "email",
    },
    {
      // fixed: "left",
      flex: 1,
      title: "Status",
      width: "150px",
      dataIndex: "status",
      key: 6,
      align: "left",
      render: (params) => {
  const statusClass = params ? params.replace(/\s+/g, '-') : '';
  return <Tag className={`tag-font-style ${statusClass}`}>{params}</Tag>;
      },
    },
    {
      // fixed: "left",
      flex: 1,
      title: "RFQ",
      width: "180px",

      dataIndex: "rfq_id",
      key: 7,
      render: (params) => {
        if (!isValidRfqId(params)) {
          return <Text >{params}</Text>;
        }

        return (
          <Link
            to={`/admin/rfq/quotes/${params}`}
            className="order-id-text"
            target="_blank"
            // onClick={() => handleNavigateToRFQDetails(params)}
          >
            {params}
          </Link>
        );
      },
    },
    {
      fixed: "left",
      width: "150px",

      flex: 1,
      key: 8,
      title: (
        <>
          <Text>{"Total"}</Text>
          {/* <PlusOutlined className="plus-icon" /> */}
        </>
      ),
      dataIndex: "total",
      align: "right",
      render: (params, record) => {
        return <Text>₹ {Number(params).toFixed(2)}</Text>;
      },
    },
  ];
  const handleNavigateCreateOrder = () => {
    navigate(
      "/admin/orders/create-order"
      // state:{rfq_id:}
    );
  };
  const handleNavigateRfqList = () => {
    navigate("/admin/rfq");
  };
  const exportOptions = [
    {
      key: 1,
      value: "Excel",
      label: "Excel",
    },
  ];
  const handleExportApi = async () => {
    let response = await excelApi({
      ...(orderReportingFilter && {reporting_manager: orderReportingFilter}),
      ...(orderStatusFilter && {status: orderStatusFilter}),
      ...(orderTypeFilter && {order_type: orderTypeFilter}),
      ...(searchedValue.search && { search: searchedValue.search }),
      ...(dateSearch.start_date && { start_date: dateSearch.start_date }),
      ...(dateSearch.end_date && { end_date: dateSearch.end_date }),
      ...(sorterState.order_id && { sort_by: sorterState.order_id }),
      ...(sorterState.created_at && { sort_by: sorterState.created_at }),
    });
   
    if(response?.data?.status === false){
      
      message.error(`${response?.data?.message}`);
      return;

    }
    if (response?.status === "fulfilled") {
      // handlePdfDownload(response?.data?.data?.url, true);
      saveAs(response?.data?.data?.url);
    }

    // excelApi();
  };

  return (
    <>
      <Col style={{ padding: "2rem" }}>
        <Row>
          <Col className="header-container">
            <Text className="heading">Orders</Text>
          </Col>
        </Row>
        <Row className="action-container">
          <Col className="action-sub-container">
            <SearchInput
              size={"large"}
              placeholder={"Search by customer name, mobile no, email"}
              getLibraryApi={orderTableApi}
              width={"400px"}
              isLoading={isLoading}
              handleSearchedValue={handleSearchedValue}
              queryparams={{
                'status' : orderStatusFilter,
                'reporting_manager' : orderReportingFilter,
                'order_type' : orderTypeFilter,
                'page' : 1,
                'start_date' : dateFilter?.start_date,
                'end_date' : dateFilter?.end_date
              }}
            />
          
            <CustomSelect
              placeholder={"Date"}
              width={"150px"}
              options={options}
              handleChange={handleChange}
              value={dateFilter}
            />
            {dateFilter === "Custom" && (
              <DateRangePicker
                onChange={handleChangeRangePicker}
                format={"DD-MMM-YYYY"}
              />
            )}

             <CustomSelect
            placeholder={"Status"}
            width={"150px"}
            options={orderStatusOptions}
            handleChange={handleStatusChange}
            value={orderStatusFilter}
          />


        <CustomSelect
            placeholder={"Assigned to"}
            width={"150px"}
            options={convertToExportOptions(reportingManagers)}
            handleChange={handleReportingChange}
            value={orderReportingFilter}

          />
          <CustomSelect
            placeholder={"Order type"}
            width={"150px"}
            options={orderTypeOptions}
            handleChange={handleOrderTypeChange}
            value={orderTypeFilter}
          />

            <CustomSelect
              placeholder={"Export"}
              width={"150px"}
              options={exportOptions}
              handleChange={handleExportApi}
              value={exlLoading ? <LoadingOutlined /> : "Export"}
              disabled={exlLoading ? true : false}
              loading={exlLoading}
            />
          </Col>
          <Col className="action-sub-container">
            <Button
              size="large"
              className="create-order-button"
              onClick={handleOpenModal}
              // onClick={handleNavigateCreateOrder}
            >
              Create order 
            </Button>
          </Col>
        </Row>
        <Col>
          {/* <Table
            className="dashboard-table"
            expandable={defaultExpandable}
            columns={columns}
            dataSource={tableDataSource}
            locale={{
              emptyText: isLoading ? <TableSkeleton /> : "",
            }}
            pagination={false}
            scroll={{ y: 1300 }}
          /> */}
          <CustomTableWithPagination
            className="order-list-table"
            tableExpandable={defaultExpandable}
            tableDataSource={tableDataSource || []}
            tableColumns={columns}
            locale={{
              emptyText: isLoading ? (
                <TableSkeleton length={10} />
              ) : (
                <NoDataFound text={"No orders found!"} />
              ),
            }}
            scroll={{ x: "100%" }}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
            itemsPerPage={20}
            totalEntries={
              !isLoading && orderData?.data?.pagination?.total_entries
            }
            isLoading={tableDataSource.length && isLoading}
            // sorterChange={sorterChange}
          />
        </Col>
      </Col>
      <CreateOrderModal
        title={"Are you sure?"}
        open={openCreateModal}
        handleCloseModal={handleCloseModal}
        handleCancel={handleNavigateCreateOrder}
        handleSave={handleNavigateRfqList}
      />
    </>
  );
};

export default ExistingOrders;
